import { s } from './Result.styles';
import ResultReport from './report/ResultReport';
import SelectedPattern from './SelectedPattern';
import { useEffect } from 'react';
import Footer from '../../../components/footer/Footer';

interface Props {
  setIsEditMode?: (value: boolean) => void;
}

const Result = ({ setIsEditMode }: Props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <s.Container
      style={{
        gap: '0',
      }}
    >
      <SelectedPattern setIsEditMode={setIsEditMode} />
      <ResultReport />
    </s.Container>
  );
};

export default Result;
